import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task405: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-405');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-405">
        <h2>zadanie 5</h2>
        <h3>{task?.title}</h3>
        <div className="decor-4">
            <p>
                Detektyw Pozytywka, właściciel małej agencji detektywistycznej “Różowe okulary”, otrzymał nietypowe zlecenie i prosi Was o pomoc!
            </p>
            <p className="instruction">
                <strong>Zadanie:</strong> Udajcie się do biblioteki i odnajdźcie trzy książki. Otwórzcie każdą z nich na losowej stronie i zapiszcie pierwsze zdanie z tej strony. Gdy zdobędziecie trzy zdania, to na ich podstawie stwórzcie pracę artystyczną!
            </p>
        </div>
        <p>
            Wytyczne:
        </p>
        <ol>
            <li>pierwsza książka stoi na drugiej półce trzeciego regału od wejścia, a jej tytuł składa się z dwóch słów</li>
            <li>druga książka ma przynajmniej 300 stron, a na jej okładce jest zwierzę</li>
            <li>trzecia książka stoi na najniższej półce, jest mniejsza od pozostałych i jej autorką jest kobieta</li>
        </ol>
    </div>
}

export default Task405;
